import annotationCompletions from './annotationCompletions.json';
import annotationDocumentCompletions from './annotationDocumentCompletions.json';
import annotationEmailCompletions from './annotationEmailCompletions.json';

export const baseCompletions = {
  annotation: annotationCompletions.map(item => ({
    ...item,
    value: `annotation.${item.value}`,
  })),
  document: annotationDocumentCompletions.map(item => ({
    ...item,
    value: `annotation.document.${item.value}`,
  })),
  email: annotationEmailCompletions.map(item => ({
    ...item,
    value: `annotation.email.${item.value}`,
  })),
} as const;
